module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "infoPackageModal",
    staticClass: "modal fade",
    attrs: {
      "id": "infoPackageModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header text-left"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-red",
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          套餐 - " + _vm._s(_vm.currentProduct[_vm.schema.product.name]) + "\n        ")])]), _vm._v(" "), (_vm.currentProduct) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('ul', {
    staticClass: "col-xs-12 nav"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.packageLayer.show),
      expression: "packageLayer.show"
    }],
    staticClass: "col-xs-12 p-x-0 line-style"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.bActiveList), function(node, nIndex) {
    return (_vm.currentProduct && _vm.checkDisableBlock(node.block.product[_vm.schema.block.product_id], _vm.currentProduct[_vm.schema.product.product_id])) ? _c('div', {
      staticClass: "col-xs-12 p-x-0 order-item adjust"
    }, [_c('h5', [_vm._v(_vm._s(node.block.product[_vm.schema.block.name]) + "\n                    "), (node.block.product[_vm.schema.block.min_limit] !== 1 && node.block.product[_vm.schema.block.min_limit] !== 0 &&
      node.block.product[_vm.schema.block.max_limit] !== 1 && node.block.product[_vm.schema.block.max_limit] !== 0 && node.block.product[_vm.schema.block.min_limit] === node.block.product[_vm.schema.block.max_limit]) ? _c('span', {
      staticClass: "text-13",
      staticStyle: {
        "top": "0px"
      }
    }, [_vm._v("(以下必選" + _vm._s(node.block.product[_vm.schema.block.min_limit]) + "項)")]) : (node.block.product[_vm.schema.block.min_limit] !== 1 && node.block.product[_vm.schema.block.min_limit] !== 0 &&
      node.block.product[_vm.schema.block.max_limit] !== 1 && node.block.product[_vm.schema.block.max_limit] !== 0) ? _c('span', {
      staticClass: "text-13",
      staticStyle: {
        "top": "0px"
      }
    }, [_vm._v("(可選擇" + _vm._s(node.block.product[_vm.schema.block.min_limit]) + " ~ " + _vm._s(node.block.product[_vm.schema.block.max_limit]) + "項)")]) : (node.block.product[_vm.schema.block.min_limit] !== 1 && node.block.product[_vm.schema.block.min_limit] !== 0) ? _c('span', {
      staticClass: "text-13",
      staticStyle: {
        "top": "0px"
      }
    }, [_vm._v("(最少可選擇" + _vm._s(node.block.product[_vm.schema.block.min_limit]) + "項)")]) : (node.block.product[_vm.schema.block.max_limit] !== 1 && node.block.product[_vm.schema.block.max_limit] !== 0) ? _c('span', {
      staticClass: "text-13",
      staticStyle: {
        "top": "0px"
      }
    }, [_vm._v("(最多可選擇" + _vm._s(node.block.product[_vm.schema.block.max_limit]) + ")")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.sortObj(node.prod)), function(node2, n2Index) {
      return _c('div', {
        staticClass: "inline-block choose-block c-pointer",
        attrs: {
          "prodActive": node2.active && _vm.checkDisableItem(node2.product[_vm.schema.product.product_id], node.block.product[_vm.schema.block.product_id]),
          "disabled": !_vm.checkDisableItem(node2.product[_vm.schema.product.product_id], node.block.product[_vm.schema.block.product_id])
        },
        on: {
          "click": function($event) {
            _vm.clickBlock(parseInt(node2.product[_vm.schema.product.product_id], 10), node)
          }
        }
      }, [(node2.product[_vm.schema.product.is_mandatory]) ? _c('span', {
        staticClass: "text-red text-14"
      }, [_vm._v("* ")]) : _vm._e(), _vm._v("\n                    " + _vm._s(node2.product[_vm.schema.product.name]) + "\n                    "), (_vm.optionNumList[0][node2.product[_vm.schema.product.product_id]] && _vm.optionNumList[0][node2.product[_vm.schema.product.product_id]] !== 1) ? _c('div', {
        staticClass: "label option-number"
      }, [_vm._v("\n                      " + _vm._s(_vm.optionNumList[0][node2.product[_vm.schema.product.product_id]]) + "\n                    ")]) : (_vm.optionNumList[0][node2.product[_vm.schema.product.product_id]] && _vm.optionNumList[0][node2.product[_vm.schema.product.product_id]] === 1 && node2.product[_vm.schema.product.max_limit] !== 1) ? _c('div', {
        staticClass: "label option-number"
      }, [_vm._v("\n                      " + _vm._s(_vm.optionNumList[0][node2.product[_vm.schema.product.product_id]]) + "\n                    ")]) : _vm._e()])
    }), _vm._v(" "), (nIndex < _vm.bActiveList.length - 1 || _vm.otherActiveList.length) ? _c('hr', {
      staticClass: "m-y-0",
      staticStyle: {
        "top": "5px"
      }
    }) : _vm._e()], 2) : _vm._e()
  }), _vm._v(" "), (_vm.currentProduct && _vm.otherActiveList.length) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 order-item adjust"
  }, [_c('h6', {}, [_vm._v("副餐")]), _vm._v(" "), _vm._l((_vm.otherActiveList), function(p, pIndex) {
    return _c('div', {
      staticClass: "inline-block choose-block c-pointer",
      attrs: {
        "prodActive": p.active
      },
      on: {
        "click": function($event) {
          _vm.clickOtherP(parseInt(p.id, 10), p)
        }
      }
    }, [(_vm.getProduct(p.id)[_vm.schema.product.is_mandatory]) ? _c('span', {
      staticClass: "text-pin text-14"
    }, [_vm._v("* ")]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.getProduct(p.id)[_vm.schema.product.name]) + "\n                    ")])
  })], 2) : _vm._e()], 2)]), _vm._v(" "), _c('ul', {
    staticClass: "col-xs-12 nav",
    staticStyle: {
      "padding-top": "6px"
    }
  }, [_c('li', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 order-item adjust"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 form-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n                    已選取商品\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-10",
    staticStyle: {
      "background": "#f4f4f4",
      "border": "3px dashed #eee",
      "border-top": "0px",
      "border-radius": "0px 0px 6px 6px"
    }
  }, [_vm._l((_vm.getProductContainer), function(pc, pcIndex) {
    return (_vm.pShow(pc)) ? _c('div', {
      staticClass: "inline-block choose-block c-pointer",
      staticStyle: {
        "border-radius": "20px"
      },
      attrs: {
        "prodActive": _vm.curProduct(pc)
      },
      on: {
        "click": function($event) {
          return _vm.clickProduct(pc)
        }
      }
    }, [(pc[_vm.schema.product.is_mandatory]) ? _c('span', {
      staticClass: "text-red text-14"
    }, [_vm._v("* ")]) : _vm._e(), _vm._v("\n                      " + _vm._s(pc[_vm.schema.product.name]) + "\n                      "), (_vm.optionNumList[0][pc[_vm.schema.product.product_id]] && _vm.optionNumList[0][pc[_vm.schema.product.product_id]] !== 1) ? _c('div', {
      staticClass: "label option-number"
    }, [_vm._v("\n                        " + _vm._s(_vm.optionNumList[0][pc[_vm.schema.product.product_id]]) + "\n                      ")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.packageLayer.show) ? _c('div', {
    staticClass: "pull-right inline-block choose-block c-pointer bg-pink text-white m-t-20 text-w-600",
    staticStyle: {
      "margin-right": "0px"
    },
    on: {
      "click": _vm.clickChoseP
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 步驟一 - 變更套餐內容\n                    ")]) : _c('div', {
    staticClass: "pull-right inline-block choose-block c-pointer bg-pink text-white m-t-20 text-w-600",
    staticStyle: {
      "margin-right": "0px"
    },
    on: {
      "click": _vm.clickChangeOption
    }
  }, [_vm._v("\n                      步驟二 - 調整商品細節 "), _c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)])]), _vm._v(" "), _vm._l((_vm.getProductContainer), function(pcDetail, pIndex) {
    return (_vm.allProduct[pcDetail[_vm.schema.product.product_id]]) ? _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.packageLayer.show && _vm.pShow(pcDetail) && _vm.curProduct(pcDetail)),
        expression: "!packageLayer.show && pShow(pcDetail) && curProduct(pcDetail)"
      }],
      staticClass: "col-xs-12 p-x-0 line-style"
    }, [_c('muti-prod', {
      ref: 'menu-options-' + pcDetail[_vm.schema.product.product_id],
      refInFor: true,
      attrs: {
        "storeState": 2,
        "modalView": _vm.modalView,
        "currentProduct": pcDetail,
        "brandId": _vm.brandId,
        "prodType": "package",
        "checkPrice": _vm.checkPrice,
        "checkAddProduct": _vm.checkAddProduct,
        "checkAddDifProduct": _vm.checkAddDifProduct,
        "productAmount": _vm.getPAmount(pcDetail),
        "optionCheck": _vm.optionCheck,
        "show": _vm.show,
        "productShow": _vm.pShow(pcDetail),
        "adjustSame": _vm.adjustSame,
        "menuJson": _vm.menuJson,
        "clickProduct": _vm.clickProduct
      }
    }), _vm._v(" "), (_vm.cheeseWording(pcDetail[_vm.schema.product.name])) ? _c('p', {
      staticClass: "text-red text-14"
    }, [_c('br'), _vm._v("★ 此產品已含起司，請斟酌加購起司")]) : _vm._e()], 1) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.adjusts.length) ? _c('li', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('hr', {
    staticStyle: {
      "margin": "15px 0px 0px 0px"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "col-xs-12 p-x-0 order-item m-t-15 p-5"
  }, [_c('p', [_vm._v("總金額：" + _vm._s(_vm.totalPrice()) + " 元")]), _vm._v(" "), _c('div', {
    staticClass: "q-numeric textfield row inline items-center input-number m-x-0 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon numeric-left c-pointer bg-pink",
    on: {
      "click": function($event) {
        _vm.number--
      }
    }
  }, [_vm._v("\n                    -\n                  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    staticClass: "no-style auto q-input-field inline-block text-center",
    attrs: {
      "type": "tel",
      "pattern": "[0-9]*",
      "tabindex": "0",
      "step": "1",
      "min": "1",
      "max": "99",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon numeric-right  c-pointer bg-pink",
    on: {
      "click": function($event) {
        _vm.number++
      }
    }
  }, [_vm._v("\n                    +\n                  ")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("關閉")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickAdd
    }
  }, [_vm._v("測試")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('p', {
    staticClass: "text-13 text-red"
  }, [_c('i', {
    staticClass: "fa fa-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 如更動套餐品項，需重新調整項目")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50c10ad2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/MenuPackageModalNew.vue
// module id = 2417
// module chunks = 1